export default __webpack_public_path__ + "static/media/GA_Mix-4.5f6b0a52.wav";